import type { SuccessResponse } from '@/api/types';
import { gateway } from '..';
import type { SurveyResource } from './resources/SurveyResource';

export function retrieveSurvey(context_type: string, context_id: number) {
    return gateway.get<SurveyResource>(`/legacy-api/v1/survey/${context_type}/${context_id}`);
}

export function createUpdateUserSurvey(action: string, survey: number, context_type: string, context_id: number) {
    return gateway.post<SuccessResponse>(`/legacy-api/v1/survey/${survey}`, {
        survey,
        action,
        context_type,
        context_id,
    });
}
